"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtgHxChartWrap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../utils/constants");
var _ChartWrapContent = require("./ChartWrapContent");
var _useGetGroupChartData = require("../../hooks/useGetGroupChartData");
var _selectors = require("../../redux/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *
 * @param siteId site id - require
 * @param {boolean} isAlarm
 * @param {string} propChartId
 * @return {JSX.Element}
 * @constructor
 */

const HtgHxChartWrap = exports.HtgHxChartWrap = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    siteId,
    isAlarm = false,
    chartId: propChartId,
    onClose
  } = _ref;
  const chartId = propChartId !== null && propChartId !== void 0 ? propChartId : "HtgHxChartWrap_".concat(siteId);
  const equipmentKey = _constants.keysForGroupChartsById.Htg;
  (0, _useGetGroupChartData.useGetGroupChartData)({
    equipmentKey,
    chartId
  });
  return /*#__PURE__*/_react.default.createElement(_ChartWrapContent.ChartWrapContent, {
    chartId: chartId,
    equipmentKey: equipmentKey,
    isAlarm: isAlarm,
    onClose: onClose,
    selectListFuncFromRedux: _selectors.selectHxList
  });
});